var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('coinflow-i-frame',{staticStyle:{"height":"40px"},attrs:{"args":_vm.iframeProps},on:{"onMessage":_vm.handleMessage}})}
var staticRenderFns = []

export { render, staticRenderFns }